import { SMALL_VIEWPORT } from "../../state/modules/layout/constants";
import styles from "./SmallViewportOnly.css";
import propTypes from "./propTypes";

const isSmall = viewport => viewport === SMALL_VIEWPORT;

const SmallViewportOnly = ({ children, viewportCategory }) =>
  isSmall(viewportCategory) ? (
    <div className={styles.container}>{children}</div>
  ) : null;

SmallViewportOnly.displayName = "SmallViewportOnly";
SmallViewportOnly.propTypes = propTypes;

export default SmallViewportOnly;
